// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"144":"ba3829d11046a840","178":"9ec0406bce82f900"}[chunkId] + ".js";
};